import React, { useEffect, useState } from 'react';
import { FileSignature, Download, CheckSquare, Square } from 'lucide-react';
import { documentsModelesApi } from '../../utils/api';
import EnvoiDocumentButton from '../../components/EnvoiDocumentButton';
import { openPdf } from '../../components/PdfPreview';

const CAT_LABELS = {
  contrat: 'Contrat',
  autorisation: 'Autorisations',
  administratif: 'Administratif',
};

export default function DocumentsAutorisations({ enfantId }) {
  const [modeles, setModeles] = useState([]);
  const [sel, setSel] = useState(() => new Set());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    documentsModelesApi.list()
      .then(r => setModeles(r.data || []))
      .catch(() => setModeles([]))
      .finally(() => setLoading(false));
  }, []);

  const toggle = (cle) => setSel(s => { const n = new Set(s); n.has(cle) ? n.delete(cle) : n.add(cle); return n; });
  const allCles = modeles.map(m => m.cle);
  const allSelected = allCles.length > 0 && allCles.every(c => sel.has(c));
  const toggleAll = () => setSel(allSelected ? new Set() : new Set(allCles));

  const generer = () => {
    if (!sel.size) return;
    openPdf(documentsModelesApi.getPdfUrl(enfantId, Array.from(sel)));
  };

  // Regrouper par catégorie
  const groupes = {};
  modeles.forEach(m => { (groupes[m.categorie] = groupes[m.categorie] || []).push(m); });

  return (
    <div className="card p-5">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <FileSignature size={17} className="text-gold-600" />
          <h3 className="font-semibold text-gray-700">Documents & Autorisations</h3>
        </div>
        <button onClick={toggleAll} className="text-[12px] text-navy-500 hover:text-navy-800 flex items-center gap-1">
          {allSelected ? <CheckSquare size={14} /> : <Square size={14} />} Tout {allSelected ? 'décocher' : 'cocher'}
        </button>
      </div>

      {loading ? (
        <div className="py-6 text-center text-gray-400 text-sm">Chargement…</div>
      ) : modeles.length === 0 ? (
        <p className="text-sm text-gray-400">Aucun modèle disponible.</p>
      ) : (
        <>
          <p className="text-[12.5px] text-gray-500 mb-3">Cochez les documents à générer. Ils seront produits en PDF <strong>à votre charte graphique</strong> et pré-remplis (enfant, structure), prêts à envoyer en signature.</p>
          <div className="space-y-4">
            {Object.keys(groupes).map(cat => (
              <div key={cat}>
                <div className="text-[11px] uppercase tracking-wide text-navy-500 font-semibold mb-1.5">{CAT_LABELS[cat] || cat}</div>
                <div className="space-y-1">
                  {groupes[cat].map(m => (
                    <label key={m.cle} className="flex items-center gap-2.5 px-2.5 py-1.5 rounded-lg hover:bg-gray-50 cursor-pointer">
                      <input type="checkbox" checked={sel.has(m.cle)} onChange={() => toggle(m.cle)} className="w-4 h-4 accent-navy-700" />
                      <span className="text-[13.5px] text-gray-800">{m.titre}</span>
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="mt-4 flex items-center gap-3 flex-wrap">
            <button onClick={generer} disabled={!sel.size} className="btn-primary disabled:opacity-50">
              <Download size={15} /> Générer {sel.size > 0 ? `(${sel.size})` : ''}
            </button>
            {sel.size > 0 && <EnvoiDocumentButton type="documents-modeles" enfantId={enfantId} docs={Array.from(sel).join(',')} label="Envoyer à la famille" />}
            {sel.size > 1 && <span className="text-[12px] text-gray-400">Un seul PDF regroupant les {sel.size} documents.</span>}
          </div>
        </>
      )}
    </div>
  );
}
